// extracted by mini-css-extract-plugin
module.exports = {"RectangleOptions":"styles_RectangleOptions__pZEIZ"};